import { useGetTodosQuery } from "../../features/todoApi/todoApiSlice";
import Error from "../ui/Error";
import TodoSkeleton from "../ui/loaders/TodoSkeleton";
import CompleteTodoCard from "./CompleteTodoCard";

export default function CompleteTodoList() {
  const {
    data: todos,
    isLoading,
    isError,
  } = useGetTodosQuery({ complete: true });

  let content;
  // Loading
  if (isLoading && !isError) {
    content = (
      <>
        {Array(5)
          .fill()
          .map((_, i) => (
            <TodoSkeleton key={i} />
          ))}
      </>
    );
  }
  // Response error
  if (!isLoading && isError) content = <Error msg={"There was an error"} />;
  // Data not found
  if (!isLoading && !isError && todos?.length === 0)
    content = <Error msg={"No todos found!"} />;
  // Response result
  if (!isLoading && !isError && todos?.length > 0)
    content = todos?.map((todo) => (
      <CompleteTodoCard todo={todo} key={todo.id} />
    ));

  return (
    <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
      {content}
    </div>
  );
}
